import React from 'react';
import { Colors } from '../Colors';
import { ResultsSummaryProps } from '../Domain/Interfaces/ResultsSummaryProps';
import { FormatPrice } from '../Functions/FormatPrice';
import { Grid, Header } from 'semantic-ui-react';

// eslint-disable-next-line max-lines-per-function
export const ResultsSummary: React.FC<ResultsSummaryProps> = ({
  canSeeDetails,
  engineResults,
  onButtonClick: onDetailsClick,
}) => {
  const onSeeDetailsClick = () => {
    onDetailsClick(!canSeeDetails);
  };

  const getColor = (value: number) => {
    return value > 0 ? Colors.riseGreen : Colors.fallRed;
  };

  if (engineResults) {
    const difference =
      engineResults.valueWithAlerts - engineResults.valueWithoutAlerts;
    return (
      <>
        <Grid.Row
          style={{
            justifyContent: 'left',
            width: '100vw',
            padding: '1rem',
          }}
        >
          <Grid.Column
            textAlign={'left'}
            style={{
              maxWidth: '800px',
              backgroundColor: Colors.darkGreen,
              borderRadius: 10,
              border: `solid 1px ${Colors.offWhite}`,
              color: Colors.offWhite,
              fontSize: 15,
              padding: 15,
            }}
          >
            <h1 className="ui row" style={{ color: Colors.orange }}>
              Summary
            </h1>
            <Header inverted>
              Past performance does not indicate future results.
            </Header>
            <Header inverted>Analysis*</Header>
            <Grid textAlign="left">
              <Grid.Row>
                <Grid.Column widescreen={5} mobile={8}>
                  Value Using RiskAlert
                </Grid.Column>
                <Grid.Column width={2} mobile={8}>
                  <span
                    style={{
                      color: getColor(engineResults.valueWithAlerts),
                      fontWeight: 800,
                    }}
                  >
                    {FormatPrice(+engineResults.valueWithAlerts.toFixed(0))}{' '}
                  </span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column widescreen={5} mobile={8}>
                  Value Holding Stock
                </Grid.Column>
                <Grid.Column widescreen={2} mobile={8}>
                  <span
                    style={{
                      color: getColor(engineResults.valueWithoutAlerts),
                      fontWeight: 800,
                    }}
                  >
                    {FormatPrice(+engineResults.valueWithoutAlerts.toFixed(0))}
                  </span>
                </Grid.Column>
                <Grid.Column></Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column widescreen={5} mobile={8}>
                  Difference in Value
                </Grid.Column>
                <Grid.Column>
                  <span
                    style={{
                      color: getColor(difference),
                      fontWeight: 800,
                    }}
                  >
                    {FormatPrice(+difference.toFixed(0))}
                  </span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column widescreen={5} mobile={8} textAlign="left">
                  Note: Cumulative Realized Gains/Loses with RiskAlert
                </Grid.Column>
                <Grid.Column>
                  <span
                    style={{
                      color: getColor(+engineResults.gainOrLoss),
                      fontWeight: 800,
                    }}
                  >
                    {FormatPrice(+engineResults.gainOrLoss.toFixed(0))}
                  </span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <i>
                    * Does not include applicable taxes, dividends or stock
                    splits.
                  </i>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Header inverted>CompareAlert</Header>
                  <p style={{ fontSize: 'large' }}>
                    CompareAlert allows you to choose a start date and
                    calculates through today's date using end of day price.
                  </p>
                  <p style={{ fontSize: 'large' }}>
                    From the start date, if the price falls below its high value
                    by your risk percentage it calculates a RiskAlert (Red Dot).
                    It assumes you sell and then monitors to the low value. If
                    the price reaches your opportunity percentage above the low
                    value, it calculates an OpportunityAlert (Green Dot). It
                    assumes you buy and reinvest the amount form your last sale.
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <div style={{ margin: '0 auto' }}>
          {!canSeeDetails && (
            <div
              className="ui button column  submit"
              onClick={onSeeDetailsClick}
            >
              See Details
            </div>
          )}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
